import { compareTwoDateTime } from '../../../helpers/datetime'

export const highlightString = (str, searchStr) => {
  if (!searchStr || !str) return str

  const searchIndex = str.toLowerCase().indexOf(searchStr.toLowerCase())
  return searchIndex !== -1 ? (
    <span>
      <span>{str.substring(0, searchIndex)}</span>
      <span className="fw600">
        {str.substring(searchIndex, searchIndex + searchStr.length)}
      </span>
      <span>{str.substring(searchIndex + searchStr.length)}</span>
    </span>
  ) : (
    <span>{str}</span>
  )
}

export const handleInternationalData = (data) => {
  return data
    .map((item) => ({
      ...item,
      organizationName: item.companyName,
      organizationId: item.companyId,
      activeStatusName: item.status,
      viewAllowed: true,
    }))
    .sort((a, b) => compareTwoDateTime(a.publicDateId, b.publicDateId))
    .reverse()
}

export const checkPreviousState = (prev, vietnam) => {
  if (Object.keys(prev).length) {
    return prev
  }

  return vietnam
}

export const handleOtherCountry = (otherCountry) => {
  return otherCountry
    .filter((item) => !item.parentCountry)
    .map((item) => ({
      ...item,
      value: item.countryCode,
      id: item.countryCode,
      label: item.country,
      name: item.country,
      code: item.countryCode,
    }))
    .sort((item1, item2) => item1.name.localeCompare(item2.name))
}
